<template>
  <div class="place">
    <div class="container position-relative">
      <ShadowTitle :title="`Место проведения`"
                   title-shadow="PLACE"/>
      <div class="row">
        <div class="col-12 col-lg-6 order-1 order-lg-0">
          <div class="place-info_title">
            Пространство событий «Матрешка» Инновационного центра Сколково
          </div>
          <div class="place-info_text">
            <p>
              «Матрешка» — деловой центр в Сколково. Это главное общественное здание инновационного центра, оно по
              праву входит в пятерку самых необычных офисных комплексов Москвы.
            </p>
            <p>
              В 2023 году «Матрешка» вошла в ТОП-20
              лучших зданий в России.
            </p>
          </div>
          <ul class="place-info_list">
            <li>
              <span>Дата проведения: </span>
              <span>9-10 марта 2024г.</span>
            </li>
            <li>
              <span>Место: </span>
              <span>Сколково, ул. Блеза Паскаля д.2</span>
            </li>
          </ul>
        </div>
        <div class="col-12 col-lg-6 order-0 order-lg-1">
          <div class="swiper-container swiper-place">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-1.png`)">
              </div>
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-2.png`)">
              </div>
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-3.png`)">
              </div>
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-4.png`)">
              </div>
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-5.png`)">
              </div>
              <div class="swiper-slide">
                <img :src="require(`@/assets/place/place-6.png`)">
              </div>
            </div>
            <div class="swiper-pagination swiper-place-pagination"></div>
            <div class="swiper-place-navigation">
              <div class="swiper-place-button swiper-place-button-prev"/>
              <div class="swiper-place-button swiper-place-button-next"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShadowTitle from "@/components/ShadowTitle";
import {nextTick, onMounted, ref} from "vue";
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/swiper.css';

export default {
  name: "Place",
  components: {ShadowTitle},
  setup() {
    const swiperInstance = ref(null);

    const initializeSwiper = () => {
      nextTick(() => {
        swiperInstance.value = new Swiper('.swiper-place', {
          loop: true,
          modules: [Navigation, Pagination],
          pagination: {
            el: '.swiper-place-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-place-button-next',
            prevEl: '.swiper-place-button-prev',
          },
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              spaceBetween: 16
            },
            400: {
              slidesPerView: 2,
              spaceBetween: 16
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 16
            },
            992: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            }
          }
        });
      });
    }

    onMounted(() => {
      initializeSwiper();
    })
  },
}
</script>

<style lang="scss" scoped>
.place {
  .place-info_title {
    font-family: Play, serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 138%; /* 35.88px */
    margin-bottom: 18px;
    @include _1200 {
      font-size: 38px;
    }
  }

  .place-info_text {
    color: var(--gray, #C7C7D1);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 20.48px */
    margin-bottom: 32px;
    @include _1200 {
      font-size: 22px;
    }

    p {
      &:not(:last-child) {
        margin-bottom: 18px;
      }
    }
  }

  .place-info_list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;

    li {
      margin-bottom: 4px;
      padding-left: 24px;
      position: relative;

      &:before {
        content: '';
        width: 16px;
        height: 16px;
        background: url(~@/assets/list-icon.svg) no-repeat center;
        position: absolute;
        left: 0;
        top: 5px;
      }

      span {
        display: flex;
        @include _1200 {
          display: inline;
        }

        &:first-child {
          font-family: Play, serif;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 112%; /* 20.16px */
          @include _1200 {
            font-size: 20px;
          }
        }

        &:last-child {
          color: var(--gray, #C7C7D1);
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 136%; /* 24.48px */
          @include _1200 {
            font-size: 22px;
          }
        }
      }
    }
  }

  .swiper-place {
    margin-bottom: 32px;
    padding-bottom: 0;

    @include _992 {
      width: 50vw;
      overflow: hidden;
      padding-bottom: 62px;
    }

    .swiper-slide {
      img {
        width: 100%;
        border-radius: 16px;
      }
    }

    .swiper-place-navigation {
      display: none;
      position: absolute;
      left: 1rem;
      @include _1400 {
        display: flex;
      }
    }

    .swiper-place-button {
      width: 60px;
      height: 60px;
      background: url(~@/assets/swiper-nav.svg) no-repeat center;
      cursor: pointer;

      &.swiper-button-disabled {
        opacity: 0.5;
      }
    }

    .swiper-place-button-next {
      transform: rotate(180deg);
      margin-left: 28px;
    }
  }
}
</style>